import React from 'react';
import { Descriptions } from 'antd';

function DetalhesOperacao({ultimoLog}) {

    return (
        <Descriptions column={1} size="small" bordered>
            <Descriptions.Item label="Status">
                <span>{ultimoLog?.statusOperacao || 'N/A'}</span>
            </Descriptions.Item>
            <Descriptions.Item label="Detalhes">
                <span>{ultimoLog?.mensagem || 'Sem detalhes disponíveis'}</span>
            </Descriptions.Item>
        </Descriptions>
    );
}

export default DetalhesOperacao;